import { colors } from '../../colors';
var form = {
  bgColor: colors.white,
  labelColor: colors.graphite,
  errorColor: colors.warningRed,
  borderColor: colors.graphite,
  linkColor: colors.petsuitesPurple,
  documentFormBgColor: colors.white,
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default form;